import { css } from 'lit';
export const style = css`
  .one-ux-element--root {
    /* Intentionally left empty for future use */
  }
`;